import { mobileMaxWidth } from "../../_common/breakPoints";
import { getQueryParams, removeQueryParams, mergeQueryParams } from "../../_common/queryParams";

const filter = `mblFilter`;
const getKey = ([key]) => key;

export function redirect(win) {
  const label = this.querySelector(`label`);
  const link = label.dataset.redirect;
  if (mobileMaxWidth.matches) {
    const mblFilter = this.parentElement.dataset.parentFilter;
    win.location = `${link}&mblFilter=${win.encodeURIComponent(mblFilter)}`;
  } else {
    win.location = link;
  }
}


export function compositeRangeComputeUrl() {
  const root = this.closest(`.product-listing-filters__composite-range`);
  const value = root.querySelector('.product-listing-filters__range-container__value').value;
  const filterId = root.dataset.filterId;
  var redirectUrl = decodeURIComponent(root.dataset.applyFilterUrlRaw || '');
  redirectUrl = redirectUrl.replace(`{{${filterId}}}`,value);
  root.dataset.applyFilterUrl = redirectUrl;
  return redirectUrl;
}

export function compositeRangeRedirect(win) {
  const root = this.closest(`.product-listing-filters__composite-range`);
  compositeRangeValidate.apply(root.querySelector('.product-listing-filters__range-container__value'));
  const redirectUrl = compositeRangeComputeUrl.apply(root.querySelector('.product-listing-filters__range-container__value'));

  if (!this.closest('.validation-error')){
    win.location = redirectUrl;
  }
}

export function compositeRangeValidate() {
  const root = this.closest(`.product-listing-filters__composite-range`);
  const val = parseFloat(this.value);
  const min = parseFloat(root.dataset.min);
  const max = parseFloat(root.dataset.max);

  if (isNaN(this.value) || val<min || val>max){
    root.classList.add('validation-error');
  }else{
    root.classList.remove('validation-error');
    compositeRangeComputeUrl.apply(this);
  }
}

export const openRefineWindow = (win, currentQuery = []) => {
  const mblFilter = currentQuery.filter(([key]) => key === filter)[0];
  if (mobileMaxWidth.matches && mblFilter) {
    const target = win.decodeURIComponent(mblFilter[1]);
    win.document.getElementById(`plp-filters-switch`).click();
    win.document.querySelector(`[data-filter-type='${target}'] span`).click();
  }
};

export function changeURL(win) {
  const currentQuery = getQueryParams(win);
  if (currentQuery.map(getKey).includes(filter)) {
    const updatedQuery = removeQueryParams(currentQuery, filter);
    win.history.replaceState({}, "", `${win.location.pathname}?${mergeQueryParams(updatedQuery)}`);
  }
}

export const initSideBarRedirect = win => {
  const currentQuery = getQueryParams(win);
  win.document.addEventListener(`MenuCloseEvent`, changeURL.bind(null, win));

  openRefineWindow(win, currentQuery);
  win.document.querySelectorAll(`.product-listing-filters__select-opt-item`).forEach(refineElement => {
    refineElement.addEventListener(`click`, redirect.bind(refineElement, win));
  });

  win.document.querySelectorAll(`.product-listing-filters__composite-range input`).forEach(refineElement => {
    refineElement.addEventListener(`change`, compositeRangeValidate.bind(refineElement, win));
  });

  win.document.querySelectorAll(`.product-listing-filters__composite-range .apply-btn > .apply`).forEach(refineElement => {
    refineElement.addEventListener(`click`, compositeRangeRedirect.bind(refineElement, win));
  });
};

export default initSideBarRedirect;



// WEBPACK FOOTER //
// ./javascript/product-search-page/sidebar-redirect/index.js